<template>
  <div>
    <CCardHeader>
      <div style="margin: auto" class="flexColumn">
        
        <JsonCSV
              v-if="tableData.length"
              color="primary"
              class="btn btn-default mb-2 clr"
              :data="tableData"
              name="Tournament users.csv"
              style="
                background: aquamarine !important;
                color: darkcyan !important;
              "
            >
              Download CSV</JsonCSV
            >
      </div>
    </CCardHeader>
    <CCard style="margin-top: 20px">
      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <template #icon="{ item }">
            <td>
              <img :Src="item.icon" class="icon" />
            </td>
          </template>
          <!-- <template #action="{ item }">
            <td>
              <CButton
                color="success"
                style="width: 100px"
                v-if="item.isSettlement"
                @click="filterdata(item)"
                >Button</CButton
              >
            </td>
          </template> -->
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import firebase from "firebase";
const db = firebase.firestore();
import moment from "moment";
import Swal from "sweetalert2";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
export default {
  components: {
    JsonCSV,
    DatePicker,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      tableData: [],
      GameName: "",
      GameId: "",
      options: [],
      value1: [],
      // userdata: [],
      // tableData2: [],
      // tableData3: [],
      fields: [
        {
          label: "created",
          key: "created",
          sortable: true,
        },
      
        {
          label: "Email",
          key: "Email",
          sortable: true,
        },
        {
          label: "Play Cost",
          key: "playCost",
          sortable: true,
        },
        {
          label: "Token Name",
          key: "tokenName",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      console.log("entered");
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      console.log("v1", v1);
      console.log("v2", v2);
      db.collection("gametournamentEntry")
        .where("entrydate", ">=", v1)
        .where("entrydate", "<=", v2)
        .orderBy("entrydate", "desc")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            // console.log(doc.data());
            this.tableData.push({
              name: doc.data().gameName,
              amount: doc.data().amount,
              email: doc.data().email,
              selectedToken: doc.data().selectedToken,
              tournamentId: doc.data().tournamentId,
              walletAddress: doc.data().walletAddress,
              amount: doc.data().amount,
              matchStartTime: moment(
                doc.data().matchStartTime.seconds * 1000
              ).format("DD-MMM-YYYY, hh:mm a"),
              entrydate: moment(doc.data().entrydate.seconds * 1000).format(
                "DD-MMM-YYYY, hh:mm a"
              ),
            });
          });
          console.log(" this.tableData.", this.tableData);
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
  },
  methods: {
    getGameNames() {
      db.collection("HTMLGames")
        .where("fixedPayout", "==", false)
        .get()
        .then((snapshot) => {
          this.tableData = [];
          // var i = 0;

          snapshot.forEach((doc) => {
            // if (i != 0) {
            this.options.push(doc.id);
            // }
            // i = i + 1;
          });
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
    filterdata() {
      console.log(this.GameId);
      console.log(this.GameName);
      let data = {
        gameName: this.GameName,
        tournamentID: this.GameId,
      };
      console.log("data", data);

      axios
        .post(
          "https://us-central1-token-geomine.cloudfunctions.net/api/getTournamentLeaderboard",
          data
          // {
          //   headers: {
          //     "Content-Type":
          //       "application/x-www-form-urlencoded; charset=UTF-8",
          //   },
          // }
        )
        .then((snapshot) => {
          this.tableData = [];
          console.log("snapshot", snapshot.data.Result);
          this.tableData = snapshot.data.Result;
          //     this.tableData.push({
          //       email: snapshot.data.email,
          //       point: snapshot.data.point,

          //   });

          console.log(" this.tableData", this.tableData);
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
    getGames(docId) {
      // console.log("game",this.GameId);
      // var startOfToday = new Date();
      // startOfToday.setHours(0, 0, 0, 0);
      // var endOfToday = new Date();
      // endOfToday.setHours(23, 59, 59, 999);

      db.collection("HTMLGamesPointsEntry")
        .where("tournamentDocId", "==", docId)
        // .where("created", ">=", startOfToday)
        // .where("created", "<=", endOfToday)
        // .orderBy("highestScore", "desc")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            // console.log(doc.data());
            this.tableData.push({
              // name: doc.data().gameName,
              // amount: doc.data().amount,
              // email: doc.data().email,
              // selectedToken: doc.data().selectedToken,
              // tournamentId: doc.data().tournamentId,
              // walletAddress: doc.data().walletAddress,
              // amount: doc.data().amount,
              created: moment(doc.data().created.seconds * 1000).format(
                "DD-MMM-YYYY, hh:mm a"
              ),
              // TournamentId: doc.data().tournamentId,
              Email: doc.data().email,
              playCost: doc.data().playCost,
              tokenName:doc.data().tokenName
              // entrydate: moment(doc.data().entrydate.seconds * 1000).format(
              //   "DD-MMM-YYYY, hh:mm a"
              // ),
            });
          });
          // console.log(" this.tableData.", this.tableData);
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getGames(this.id);
    // this.getGameNames();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>
